import { CommonModule } from '@angular/common';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { setPlan } from '@oneqrew-partnertool/core';
import { FaqsComponent } from '@oneqrew-partnertool/faqs';
import { Plan } from '@oneqrew-partnertool/models';
import { ModuleAddonsComponent } from '@oneqrew-partnertool/module-addons';
import { PlanUpgradeComponent } from '@oneqrew-partnertool/plan-upgrade';
import { NewPlanComponent } from '@oneqrew-partnertool/new-plan';
import { SubscriptionPlansComponent } from '@oneqrew-partnertool/subscription-plans';
import { handlePlanCheck } from '@oneqrew-partnertool/utils';
import { DialogModule } from 'primeng/dialog';
import { OrderAppAccessDialogComponent } from '@oneqrew-partnertool/order-app-access-dialog';
@Component({
  selector: 'app-front-page',
  standalone: true,
  imports: [
    CommonModule,
    FaqsComponent,
    ModuleAddonsComponent,
    PlanUpgradeComponent,
    SubscriptionPlansComponent,
    NewPlanComponent,
    DialogModule,
    OrderAppAccessDialogComponent
  ],
  templateUrl: './front-page.component.html'
})
export class FrontPageComponent implements OnInit {
  @Input() isSubPage = false;
  @Input() isNewPlanPage = false;
  loading = true;
  plans: Plan[] = [];
  showAccessDialog: boolean = true;

  constructor(private store: Store, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.data.subscribe((data: { [key: string]: any }) => {
      this.isNewPlanPage = data['isNewPlanPage'];
      this.plans = data['plans'];
      handlePlanCheck(
        this.store,
        (plan) => {},
        () => {
          this.store.dispatch(setPlan(this.plans[0]));
        }
      );
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    $event.returnValue = 'Beim erneuten Laden der Seite gehen die ausgewählten Module und der Plan verloren.';
  }

  closeDialog() {
    this.showAccessDialog = false;
  }
}
